import { useState, useRef, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import SignaturePad from 'react-signature-canvas'
import '../formcomponents/ElectronicSignature.css'
import IformBreadcrumb from '../formcomponents/iformBreadcrumb'
import { Grid, Box, Paper, Stack, useMediaQuery } from '@mui/material'
import { Typography, Button } from '@nwh-consumer-digital/nw-component-lib'
import ErrorMessage from '../formcomponents/errorMessage'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'

const Item = styled(Paper)(({ theme }) => ({
  textAlign: 'left',
  minHeight: '65px',
  lineHeight: '60px',
}))

const styles = {
  signatureSectionCont: {
    padding: '10px',
  },
  errorMsgCont: {
    display: 'block',
    clear: 'both',
    width: '100%',
    paddingTop: '40px',
  },
}

const minorPageThree = (props) => {
  const isMobile = useMediaQuery('(max-width:600px)')

  // Use Context Provider to Update Progress
  const { updateProgress } = useProgress()

  // Set Value For Progress
  updateProgress(80)

  //Scroll to top when page mounts
  const scrolltoTop = function () {
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    scrolltoTop()
  }, [])

  // Setup Ref for Signature Pad Container and Handle Error States  const cardRef = useRef(null)
  const cardRef = useRef(null)

  const removeBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '1px solid #cccccc'
    }
  }
  const addBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '3px solid red'
    }
  }

  const handleSignature = () => {
    setTimeout(() => {
      setIsSigned(true)
    }, 300)
    removeBottomBorderRed()
  }

  const { SubmissionState, onFormStateChange } = props
  const {
    register,
    handleSubmit,
    setValue,
    formState: {},
  } = useForm()
  const [isSigned, setIsSigned] = useState(false)
  const [imageURL, setImageURL] = useState(null)
  const signData = useRef({})

  const setCardColor = function (color) {
    let SigCardSt = document.getElementsByClassName('Card')
    let SigPadBk = document.getElementsByClassName('SigPad')
    SigPadBk[0].style.backgroundColor = color
    SigCardSt[0].style.backgroundColor = color
  }

  const clear = () => {
    setImageURL('reset')
    addBottomBorderRed()
    setIsSigned(false), signData.current.clear(), setCardColor('#FAFAFA')
  }

  const save = () =>
    setImageURL(
      signData.current.getTrimmedCanvas().toDataURL('image/png'),
      setValue('imageURLStr', 'True'),
      setCardColor('#E8F0FE'),
      setIsSigned(true),
    )

  const saveIfNotEmpty = () => {
    if (signData.current.isEmpty()) {
      alert('You must sign document')
    } else {
      save()
    }
  }

  const handleRegistration = (data) => {
    if (imageURL) {
      setValue('imageURLStr', 'True')
      setIsSigned(true)
    }

    data.imageUrl = imageURL
    data.uploadFiles = 'See Folder Images'
    SubmissionState.sec = data
    SubmissionState.sectionThreeForm = data
    SubmissionState.sectionThreSubmitted = true
    SubmissionState.goBackPageOne = false
    SubmissionState.goBackPageTwo = false
    SubmissionState.goBackLogin = false
    SubmissionState.submitCompletedForm = true
    onFormStateChange()
  }

  const previousPageClick = () => {
    SubmissionState.showPageThree = false
    SubmissionState.showPageTwo = true
    SubmissionState.goBackPageTwo = true
    SubmissionState.goPageThree = false
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container spacing={1} justifyContent="space-between" alignItems="left">
        <Grid
          item
          xs={12}
          sx={{
            marginTop: { xs: '1.25rem', sm: '1.25rem', md: '1.25rem', lg: '2rem', xl: '2rem' },
            marginBottom: { xs: '2rem', sm: '2rem', md: '2rem', lg: '2rem', xl: '2rem' },
          }}>
          <IformBreadcrumb onClick={previousPageClick}>&lt; Su información</IformBreadcrumb>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h1" style={{ marginBottom: 24 }}>
            Firmando abajo, reconozco y acepto que:
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Item elevation={0}>
            <Typography type="body" size="large" weight="light">
              <ul>
                <li>Soy el padre/madre o el tutor legal del paciente mencionado arriba.</li>
                <li>
                  No hay órdenes judiciales ni órdenes de restricción vigentes que limiten mi acceso al expediente
                  médico o a la información de este menor.
                </li>
                <li>
                  Debo cumplir los términos y condiciones del sitio web de Northwell sobre el acceso a la información
                  del niño en los portales para pacientes de Northwell.
                </li>
                <li>
                  Northwell da el acceso a los portales para pacientes como una ventaja para sus pacientes y familias, y
                  Northwell puede desactivar el acceso a los mismos en cualquier momento y por cualquier motivo.
                </li>
                <li>
                  Entiendo que el acceso como apoderado incluirá información médica limitada y específica del expediente
                  médico del menor. Puedo pedir una copia del expediente médico completo del menor por otros medios.
                </li>
                <li>
                  Entiendo que el acceso como apoderado a la cuenta del menor terminará automáticamente cuando el niño
                  cumpla 13 años.
                </li>
                <li>
                  Por el presente, certifico que soy el padre/madre o el tutor legal del paciente mencionado en este
                  formulario, y que tengo derecho a consultar su información médica. (Adjunte documentación legal
                  complementaria, si corresponde).
                </li>
              </ul>
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 24 }}>
          <Typography type="body" size="large" weight="light">
            {' '}
            Por el presente, certifico que soy el padre/madre o el tutor legal del paciente mencionado en este
            formulario, y que tengo derecho a consultar su información médica.
          </Typography>
        </Grid>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12}>
            <Item elevation={0}>
              <div className="Card" ref={cardRef}>
                <Typography type="body" size="small" weight="plain" style={{ marginTop: 10, marginLeft: 16 }}>
                  {' '}
                  Se requiere firma<span className="red"> *</span>
                </Typography>{' '}
                <div className="SigContainer">
                  <SignaturePad
                    onEnd={handleSignature}
                    penColor="black"
                    canvasProps={{ className: 'SigPad' }}
                    ref={signData}
                  />
                  <div>{!isSigned ? <ErrorMessage message="A signature is required." /> : null}</div>
                  <Stack spacing={2} direction={isMobile ? 'column' : 'row'}>
                    <Button size="medium" color="primary" onClick={saveIfNotEmpty} type="submit" text="Submit" />
                    <Button size="medium" color="secondary" onClick={clear} type="button" text="Reset Signature" />
                  </Stack>
                </div>
              </div>
              <input {...register('imageURLStr', { required: true })} type="hidden" />
              <div style={styles.errorMsgCont}></div>
            </Item>
          </Grid>
        </form>
      </Grid>
    </Box>
  )
}
export default minorPageThree
